var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingDeep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4v16a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H6a1 1 0 00-1 1zM3 20a3 3 0 003 3h12a3 3 0 003-3V4a3 3 0 00-3-3H6a3 3 0 00-3 3v16z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M11.99 6c-.447 0-.837.382-.837.818v.327C10.037 7.418 9.2 8.4 9.2 9.545v.819c0 1.363 1.116 2.454 2.51 2.454h.558c.502 0 .837.328.837.818v.819c0 .49-.335.818-.837.818h-.558c-.502 0-.836-.328-.836-.819 0-.436-.39-.818-.837-.818-.446 0-.837.382-.837.819 0 1.145.837 2.127 1.953 2.4v.327c0 .436.39.818.836.818.447 0 .837-.382.837-.818v-.327c1.116-.273 1.953-1.255 1.953-2.4v-.819c0-1.363-1.116-2.454-2.51-2.454h-.559c-.502 0-.836-.328-.836-.818v-.819c0-.49.335-.818.836-.818h.558c.502 0 .837.328.837.818 0 .437.39.819.837.819.446 0 .837-.382.837-.819 0-1.145-.837-2.127-1.953-2.4v-.327A.812.812 0 0011.99 6z",
    fill: "#000"
  })));
}
export default SvgBillingDeep;